<template>
  <el-dialog
      :title="$t('text.cardMonitorLog')"
      :visible.sync="isShowLogDialog"
      width="1200px"
      @close="handleDialog"
  >
    <div v-if="logDialogValue">
      <div class="order-number-list">
        <div>
          <el-tag>{{ $t("text.cardName") }}</el-tag>
          {{ getCardTypeName(logDialogValue.cardType) }}
          <el-tag type="success">{{ $t("text.deviceId") }}</el-tag>
          {{ logDialogValue.deviceId }}

          <el-tag type="warning">{{ $t("text.creationTime") }}</el-tag>
          {{ $formatter.formatDateToDate(null, null, logDialogValue.createTime, null) }}

        </div>
      </div>
    </div>

    <el-table :data="logList" v-loading="loading">
      <el-table-column
          prop="logTime"
          width="160px"
          :label="$t('text.time')"
      ></el-table-column>
      <el-table-column :label="$t('text.receivedNotification')">
        <template slot-scope="scope">
          {{ scope.row.received.notificationMessage }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('text.customerName')" prop="customerName" width="200px"> </el-table-column>

      <el-table-column :label="$t('text.amountReceived')" prop="amountReceived" width="100px"> </el-table-column>

      <el-table-column prop="message" :label="$t('text.log')"></el-table-column>

    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleDialog">{{ $t("text.cancel") }}</el-button>
      <el-button type="primary" @click="logDetail" :loading="loading">{{
          $t("text.refresh")
        }}</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  props: {
    isShowLogDialog: {
      type: Boolean,
      default: false,
    },
    logDialogValue: {
      type: Object,
      default: null,
    },
    cardTypeList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      logList: [],
      loading: false,
    };
  },
  created() {
    this.logDetail();
  },
  methods: {
    logDetail() {
      this.loading = true;
      this.$axios.get("/card/selectLog", {
            params: {
              deviceId: this.logDialogValue.deviceId,
              receiverCardOrganization: this.logDialogValue.receiverCardOrganization
            }
          }
      ).then((res) => {

        if (res.code === 200) {
          this.logList = res.data;

          this.logList = this.logList.map(item => {
            const received = JSON.parse(item.message.replace("Received app notification: ", ""));
            const sdaPayregex = /^(.*?) sent you PKR (\d+)/;
            const oPayregex = /^You have received Rs\. (\d+\.\d{2}) from (.+?) from.*$/;
            const message = received.notificationMessage;
            const sdaPayMatch = message.match(sdaPayregex);
            const oPayMatch = message.match(oPayregex);
            let customerName = ' -- ';
            let amountReceived = ' -- ';

            if (sdaPayMatch) {
              customerName = sdaPayMatch[1];
              amountReceived = sdaPayMatch[2];
            } else if (oPayMatch) {
              customerName = oPayMatch[2];
              amountReceived = oPayMatch[1];
            }

            return {
              ...item,
              received: received,
              amountReceived: amountReceived,
              customerName: customerName
            };
          });
          console.log(this.logList)
        } else {
          this.$message.error('Search Fail Message: ' + res.msg);
        }
      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.loading = false;
      })
    },
    handleDialog() {
      this.$emit("update:isShowLogDialog", false);
      this.$emit("update:logDialogValue", null);
    },
    getCardTypeName(value) {
      return this.cardTypeList.filter(x => x.value === value)[0].name;
    },
  },
};
</script>
<style lang="scss" scoped>
.order-number-list {
  display: flex;
  align-items: center;
  gap: 24px;

  span {
    display: inline-block;
    margin-left: 10px;
  }
}

.order-info-table {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  margin-bottom: 16px;
  border-left: 1px solid #d3dce6;
  border-radius: 4px;

  th,
  td {
    border: 1px solid #d3dce6;
  }

  th {
    border-left: none;
    border-right: none;
  }

  tr {
    width: 50%;
    display: flex;
  }

  th {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 88px;
    background-color: #ebeef5;
    font-weight: bold;
  }

  td {
    flex: 1;
    padding: 12px 16px;
  }

  tr:nth-child(1),
  tr:nth-child(2) {
    td {
      border-bottom: none;
    }
  }

}
</style>
